"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _htmlReactParser = _interopRequireDefault(require("html-react-parser"));
var _FigureModule = _interopRequireDefault(require("./../../scss/blocks/Figure.module.scss"));
function Figure(_ref) {
  let {
    image = {
      url: '',
      altText: '',
      caption: ''
    }
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("figure", {
    className: _FigureModule.default['figure'],
    title: image.altText !== '' ? image.altText : ''
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: image.url,
    alt: image.altText
  }), (image === null || image === void 0 ? void 0 : image.caption) && /*#__PURE__*/_react.default.createElement("figcaption", null, (0, _htmlReactParser.default)(image.caption)));
}
var _default = exports.default = Figure;